import { defineMessages } from "react-intl"

export const messages = defineMessages({
    listingHeader: {
        id: "payment_processing.terminal_listing.header",
        defaultMessage: "Terminals",
    },
    newTerminalButton: {
        id: "payment_processing.terminal_listing.add_new_terminal",
        defaultMessage: "Add new terminal",
    },
    deviceNameHeader: {
        key: "payment_processing.terminal_listing.header.device_name",
        id: "payment_processing.terminal_listing.header.device_name",
        defaultMessage: "Name",
    },
    deviceModelHeader: {
        key: "payment_processing.terminal_listing.header.device_model",
        id: "payment_processing.terminal_listing.header.device_model",
        defaultMessage: "Model",
    },
    deviceStatusHeader: {
        key: "payment_processing.terminal_listing.header.device_status",
        id: "payment_processing.terminal_listing.header.device_status",
        defaultMessage: "Status",
    },
    noTerminalsHeader: {
        id: "payment_processing.no_terminal.header",
        defaultMessage: "Pair your first terminal",
    },
    noTerminalsBody: {
        id: "payment_processing.no_terminal.body",
        defaultMessage: "click \"Add new terminal\" to register and pair a terminal to your QM Account.",
    },
})


// WEBPACK FOOTER //
// ./src/payment-processing/terminal-listing/messages.ts